// import jQuery from 'CommonScripts/jquery-1.10.2';

(function (window, document, $) {

    $(document).ready(function () {

        /* Return to top functionality */

        $('body').append('<div id="ReturnToTop"><a href="#"></a></div>');

        //$.components.registerComponent('#ReturnToTop', function ($root) {
            var $root = document.getElementById('ReturnToTop');
            $root = $($root);
                     
            var ReturnToTop = {
                dom: {
                    base: $root
                },
                set: {
                    speed: 300,
                    showing: false,
                    scrollTimeout: null
                },
                fn: {
                    showButton: function () {
                        if ($set.showing === true) {
                            return;
                        }

                        $dom.base.fadeIn($set.speed);
                        $dom.base.animate({ bottom: '0%' }, $set.speed);

                        $set.showing = true;
                    },
                    hideButton: function () {
                        if ($set.showing === false) {
                            return;
                        }
                        $dom.base.animate({ bottom: '-100%' }, $set.speed);
                        $dom.base.fadeOut($set.speed);

                        $set.showing = false;
                    },
                    returnToTop: function () {
                        $('html, body').animate({ scrollTop: 0 }, $set.speed);
                    },
                    checkToShowOrHide: function (){
                        if ($(window).scrollTop() > $(window).height()) {
                            $fn.showButton();
                        } else {
                            $fn.hideButton();
                        }
                        $set.scrollTimeout = null;
                    }
                }
            },
            $dom = ReturnToTop.dom,
            $set = ReturnToTop.set,
            $fn = ReturnToTop.fn;

            /* When loading the component, check if the page is scrolled */
            if ($(window).scrollTop() > $(window).height()) {
                $fn.showButton();
            }

            /* Show or hide the button when scrolling through the page with 100ms of delay */
            $(window).on('scroll', function () {
                if (!$set.scrollTimeout) {
                    $set.scrollTimeout = setTimeout(function () { $fn.checkToShowOrHide() }, 100);
                }
                
            });

            $dom.base.on({
                click: function (e) {
                    e.preventDefault();
                    $fn.returnToTop();
                    return false;
                }
            }, 'a');
        //});

});

})(window, document, jQuery);
